import type { Job } from "../types/job";

// Newest-first ordering for the Queue/History tabs, plus the client-side
// 24h auto-archive partition (queue item older than 24h renders under
// History instead — server state/status is untouched, this is display only).

const sortTs = (j: Job) => new Date(j.createdAt || j.updatedAt || 0).getTime();
const createdTs = (j: Job) => new Date(j.createdAt || 0).getTime();

export function sortByCreatedAtDesc(jobs: Job[]): Job[] {
  return [...jobs].sort((a, b) => sortTs(b) - sortTs(a));
}

export const ARCHIVE_AFTER_MS = 24 * 60 * 60 * 1000;

// Approve edilmiş (veya reddedilmiş) bir job — ör. Merlin animatör popup'ının
// kendi approveJob çağrısıyla, widget tepsisinin dışından onaylanmış — artık
// Kuyruk'ta değil Geçmiş'te görünmeli. Sunucu durumu değişmez, sadece görünüm.
export function partitionByApproval(jobs: Job[]): { active: Job[]; archived: Job[] } {
  const active: Job[] = [];
  const archived: Job[] = [];
  for (const job of jobs) {
    (job.approved || job.status === "approved" || job.status === "declined"
      ? archived
      : active
    ).push(job);
  }
  return { active, archived };
}

export function partitionByAge(
  jobs: Job[],
  now: number,
  ageMs: number = ARCHIVE_AFTER_MS
): { active: Job[]; archived: Job[] } {
  const active: Job[] = [];
  const archived: Job[] = [];
  for (const job of jobs) {
    (now - createdTs(job) > ageMs ? archived : active).push(job);
  }
  return { active, archived };
}

// Folds auto-archived queue items into the fetched history list — de-duped
// by id (a job already present in fetched history wins) and re-sorted.
export function mergeIntoHistory(history: Job[], archived: Job[]): Job[] {
  const ids = new Set(history.map((j) => j.id));
  return sortByCreatedAtDesc([...history, ...archived.filter((j) => !ids.has(j.id))]);
}
